import type { User } from '@dhl/keycloak-user-api'

const csvHeaderRow = 'id;username;firstName;lastName;roles'

export const usersToCsv = (users: User[]): string => {
  const usersCsv = users.map((user) => {
    const roles = (user.roles || [])
      .map((role) => role.name)
      .sort((a, b) => a.localeCompare(b))
      .join(',')
    return `${user.id};${user.username};${user.firstName};${user.lastName};${roles}`
  })
  const fullCsv = [csvHeaderRow, ...usersCsv]
  return fullCsv.join('\n')
}
